import {
    PRINT_PDF_LOADING,
    SET_PDF_URL_FOR_SHARING,
    CLEAR_PDF_URL_FOR_SHARING,
    PRINT_PDF_RESET_SUCCESS,
    PRINT_PDF_SUCCESS
} from '../actionTypes/printPdfActionTypes';

import type { Reducer } from 'redux';
import type { SharingType } from '../types/types';

type PrintPdfState = {
    loading: boolean;
    sharingUrl?: string;
    sharingType?: SharingType;
    isError: boolean;
    isSuccess: boolean;
    isPublishing?: boolean;
};

const initialState: PrintPdfState = {
    loading: false,
    isError: false,
    isSuccess: false,
    isPublishing: false
};

export type PrintPdfReducer = Reducer<PrintPdfState>;

export const reducer: PrintPdfReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case PRINT_PDF_LOADING:
            return {
                ...state,
                loading: action.payload.loading,
                forSharing: action.payload.forSharing,
                isPublishing: action.payload.isPublishing,
                isError: false,
                isSuccess: false
            };
        case PRINT_PDF_RESET_SUCCESS:
            return {
                ...state,
                isSuccess: false
            };
        case PRINT_PDF_SUCCESS:
            return {
                ...state,
                isSuccess: true,
                loading: false,
                isPublishing: false
            };
        case SET_PDF_URL_FOR_SHARING:
            return {
                ...state,
                sharingUrl: action.payload.url,
                sharingType: action.payload.type
            };
        case CLEAR_PDF_URL_FOR_SHARING:
            return {
                ...state,
                sharingUrl: undefined,
                sharingType: undefined
            };
        default:
            return state;
    }
};
